import ButtonWidget from './ButtonWidget';
import ButtonWidgetControl from './ButtonWidgetControl';
import { Config } from './types';
import {
  defaultSizeLocationData,
  defaultTypographyData,
  defaultBorderData,
  defaultHoverBorderData,
} from 'builder/util/constants';

export default {
  type: 'Button',
  displayName: 'Button',
  icon: 'Button',
  site: '',
  initialConfig: {
    ...defaultSizeLocationData,
    ...defaultTypographyData,
    ...defaultBorderData,
    iconStyle: 'Without Icon',
    icon: {
      url: '',
      alt: '',
    },
    iconPlacement: 'Left',
    width: 240,
    height: 80,
    minWidth: 75,
    minHeight: 85,
    textColor: 'white',
    characterSpacing: 0,
    lineSpacing: 1,
    align: 'center',
    centerAlign: true,
    borderData: {
      ...defaultBorderData.borderData,
      radius: 10,
    },
    paddingData: {
      top: 10,
      bottom: 10,
      left: 10,
      right: 10,
    },
    uniqueId: '123abc',
    lineColor: 'red',
    backgroundData: { style: 'Color', color: '#002667' },
    parentId: '',
    currentTab: 0,
    displayText: 'My Button Text',
    newTab: false,
    linkType: 'None',
    emailAddress: '',
    emailSubject: '',
    url: '',
    iconColor: '',
    buttonAnalyticsText: '',
    hoverData: {
      ...defaultSizeLocationData,
      ...defaultTypographyData,
      ...defaultHoverBorderData.borderData,
      iconStyle: 'Without Icon',
      icon: {
        url: '',
        alt: '',
      },
      iconPlacement: 'Left',
      width: 240,
      height: 90,
      minWidth: 20,
      minHeight: 20,
      textColor: 'white',
      align: 'center',
      centerAlign: true,
      borderData: {
        ...defaultBorderData.borderData,
        radius: 10,
      },
      paddingData: {
        top: 10,
        bottom: 10,
        left: 10,
        right: 10,
      },
      uniqueId: '123abc',
      lineColor: 'red',
      backgroundData: { style: 'Color', color: '#0c55b8' },
      parentId: '',
      site: null,
      displayText: '',
      uploadedFile: {
        name: '',
        url: '',
      },
    },
    visible: true,
  },
  components: {
    render: ButtonWidget,
    control: ButtonWidgetControl,
  },
  copyable: true,
} as HorizonWidgetDefinition<Config>;
